class FloatingInput extends HHBaseElement {
  constructor() {
    super()
    this._handleFocus = this._handleFocus.bind(this)
    this._handleFocusOut = this._handleFocusOut.bind(this)
    this.$input = this.querySelector('input')
    this.$textarea = this.querySelector('textarea')
    this.$inputType = this.getAttribute('inputType').trim()

    console.log('this.$inputType', this.$inputType)
  }

  connectedCallback() {
    if (this.$inputType === 'input') {
      this.$input.addEventListener('focus', this._handleFocus)
      this.$input.addEventListener('focusout', this._handleFocusOut)
      this.$input.previousElementSibling.addEventListener(
        'click',
        this._handleFocus
      )
      if (!!this.$input.value) {
        this._activate()
      }

      // Refresh Input after Customer Fields have Loaded to make sure UI is updated
      document.addEventListener(
        'cf:customer_ready',
        () => {
          setTimeout(() => {
            if (!!this.$input.value) {
              this._activate()
            }
          }, 500)
        },
        { once: true }
      )
    } else {
      this.$textarea.addEventListener('focus', this._handleFocus)
      this.$textarea.addEventListener('focusout', this._handleFocusOut)
      this.$textarea.previousElementSibling.addEventListener(
        'click',
        this._handleFocus
      )
      if (!!this.$textarea.value) {
        this._activate()
      }

      // Refresh Input after Customer Fields have Loaded to make sure UI is updated
      document.addEventListener(
        'cf:customer_ready',
        () => {
          setTimeout(() => {
            if (!!this.$textarea.value) {
              this._activate()
            }
          }, 500)
        },
        { once: true }
      )
    }
  }

  disconnectedCallback() {
    if (this.$inputType === 'input') {
      this.$input.removeEventListener('focus', this._handleFocus)
      this.$input.removeEventListener('focusout', this._handleFocusOut)
      this.$input.previousElementSibling.removeEventListener(
        'click',
        this._handleFocus
      )
    } else {
      this.$textarea.removeEventListener('focus', this._handleFocus)
      this.$textarea.removeEventListener('focusout', this._handleFocusOut)
      this.$textarea.previousElementSibling.removeEventListener(
        'click',
        this._handleFocus
      )
    }
  }

  _activate() {
    if (this.$inputType === 'input') {
      this.$input.previousElementSibling.classList.add('active')
    } else {
      this.$textarea.previousElementSibling.classList.add('active')
    }
    this.classList.add('active')
  }

  _deactivate() {
    if (this.$inputType === 'input') {
      if (this.$input.value === '') {
        this.$input.previousElementSibling.classList.remove('active')
      }
    } else {
      if (this.$textarea.value === '') {
        this.$textarea.previousElementSibling.classList.remove('active')
      }
    }
    this.classList.remove('active')
  }

  _handleFocus() {
    this._activate()

    if (this.$inputType === 'input') {
      this.$input.focus()
    } else {
      this.$textarea.focus()
    }
  }

  _handleFocusOut() {
    this._deactivate()
  }
}
window.customElements.define('floating-input', FloatingInput)
